import { jsx as _jsx } from "react/jsx-runtime";
import { radius } from "../../../core/design-system/index.js";
import { Container } from "./basic.js";
export function StepBar(props) {
    return (_jsx(Container, { bg: "tertiaryBg", flex: "row", style: {
            height: "8px",
            borderRadius: radius.lg,
        }, children: _jsx(Container, { bg: "accentText", style: {
                width: `${(props.currentStep / props.steps) * 95}%`,
                borderRadius: radius.lg,
            }, children: null }) }));
}
//# sourceMappingURL=StepBar.js.map